import { KEYS, store } from './storage';

/**
 * A code chunk that failed to load. After a redeploy, a tab still running the
 * old index.html asks for hashed files that no longer exist. Browsers word it
 * differently; Vite's own preload errors are covered too.
 */
export function isChunkLoadError(err: unknown): boolean {
  if (!(err instanceof Error)) return false;
  return /dynamically imported module|importing a module script failed|unable to preload|failed to load module script/i.test(err.message);
}

/** Don't reload again within this long of the last try: that's a loop, not a stale tab. */
const RELOAD_GUARD_MS = 10_000;

/**
 * Reload once when a chunk fails to load, which picks up the new index.html.
 * Returns whether it reloaded; if the reload didn't help, the error goes on to
 * the route error page, which offers a manual reload.
 */
export function reloadForStaleChunk(now = Date.now(), reload = () => window.location.reload()): boolean {
  const last = Number(store.get(KEYS.chunkReload, 'session'));
  if (last && now - last < RELOAD_GUARD_MS) return false;
  store.set(KEYS.chunkReload, String(now), 'session');
  reload();
  return true;
}

export function reloadOnStaleChunks(): void {
  window.addEventListener('vite:preloadError', () => void reloadForStaleChunk());
}
